"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = void 0;
var Model;
(function (Model) {
    Model["QICORE"] = "QI-Core v4.1.1";
    Model["QICORE_6_0_0"] = "QI-Core v6.0.0";
    Model["QICORE_7_0_0"] = "QI-Core v7.0.0";
    Model["QDM_5_6"] = "QDM v5.6";
})(Model = exports.Model || (exports.Model = {}));
